import { useMixpanelContext } from '../../providers/MixpanelContext';
import { useUserContext } from '../../providers/UserContext';
import { ReactComponent as LinkIcon } from '../../assets/image/arrow-square-out.svg';

interface StandaloneProps {
  title: string;
  link: string;
  mixpanelEventName?: string | null;
  sessionId: number;
}

function StandaloneLink({ title, link, mixpanelEventName = null, sessionId }: StandaloneProps) {
  const { mixpanelTrackEvent } = useMixpanelContext();
  const { tutorByIesId } = useUserContext();

  const openLinkInNewTab = () => {
    window.open(link, '_blank');
    if (mixpanelEventName) {
      mixpanelTrackEvent(mixpanelEventName, {
        tutor: tutorByIesId,
        sessionId,
      });
    }
  };
  return (
    <button type="button" className="standalone-link" onClick={() => openLinkInNewTab()}>
      {title}
      <span style={{ height: '16px', width: '16px' }}>
        <LinkIcon />
      </span>
    </button>
  );
}

export default StandaloneLink;
